import api from "../api/flexapi";
import { toArrayOfIdAndValue } from "cxa-utils";
import { SubmissionError } from "redux-form";
import { showToast } from "./toastActions";

export const FETCH_HRA_RESULT_REQUEST = "FETCH_HRA_RESULT_REQUEST";
export const FETCH_HRA_RESULT_SUCCESS = "FETCH_HRA_RESULT_SUCCESS";
export const FETCH_HRA_RESULT_FAILURE = "FETCH_HRA_RESULT_FAILURE";

export const FETCH_HRA_RESULT_DETAIL_REQUEST = "FETCH_HRA_RESULT_DETAIL_REQUEST";
export const FETCH_HRA_RESULT_DETAIL_SUCCESS = "FETCH_HRA_RESULT_DETAIL_SUCCESS";
export const FETCH_HRA_RESULT_DETAIL_FAILURE = "FETCH_HRA_RESULT_DETAIL_FAILURE";

export const FETCH_WELLNESS_PRIORITIES_REQUEST = "FETCH_WELLNESS_PRIORITIES_REQUEST";
export const FETCH_WELLNESS_PRIORITIES_SUCCESS = "FETCH_WELLNESS_PRIORITIES_SUCCESS";
export const FETCH_WELLNESS_PRIORITIES_FAILURE = "FETCH_WELLNESS_PRIORITIES_FAILURE";

export const SET_WELLNESS_PRIORITIES_REQUEST = "SET_WELLNESS_PRIORITIES_REQUEST";
export const SET_WELLNESS_PRIORITIES_SUCCESS = "SET_WELLNESS_PRIORITIES_SUCCESS";
export const SET_WELLNESS_PRIORITIES_FAILURE = "SET_WELLNESS_PRIORITIES_FAILURE";

export const SET_UNSUBMITTED_PRIORITIES = "SET_UNSUBMITTED_PRIORITIES";

export const SELECT_HEALTH_REVIEW_TAB = "SELECT_HEALTH_REVIEW_TAB";

export function fetchHraResult() {
  return dispatch => {
    dispatch({ type: FETCH_HRA_RESULT_REQUEST, payload: null });

    api
      .getHraResult()
      .then(response => {
        //TODO : It would have made life easier if the payload is already normalized.
        //       Like converting all "true"/"false" to bool.
        //       However, this will break a few components, but I think it's still manageable.
        dispatch({ type: FETCH_HRA_RESULT_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: FETCH_HRA_RESULT_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function fetchHraResultDetail(riskDomain) {
  return dispatch => {
    dispatch({ type: FETCH_HRA_RESULT_DETAIL_REQUEST, payload: riskDomain });

    api
      .getHraResultDetails(riskDomain)
      .then(response => {
        dispatch({
          type: FETCH_HRA_RESULT_DETAIL_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_HRA_RESULT_DETAIL_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function fetchWellnessPriorities() {
  return dispatch => {
    dispatch({ type: FETCH_WELLNESS_PRIORITIES_REQUEST, payload: null });

    api
      .getWellnessPriorities()
      .then(response => {
        dispatch({
          type: FETCH_WELLNESS_PRIORITIES_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_WELLNESS_PRIORITIES_FAILURE,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export const setWellnessPriorities = data => dispatch => {
  dispatch({ type: SET_WELLNESS_PRIORITIES_REQUEST, payload: null });

  const formattedData = {
    data: toArrayOfIdAndValue(data),
  };

  return api
    .postWellnessPriorities(formattedData)
    .then(response => {
      dispatch({
        type: SET_WELLNESS_PRIORITIES_SUCCESS,
        payload: response.body,
      });
      if (response && response.body && response.body.data) {
        dispatch(showToast({ message: "PRIORITY_SAVED_SUCCESSFULLY_MESSAGE" }));
      }
    })
    .catch(err => {
      dispatch({
        type: SET_WELLNESS_PRIORITIES_FAILURE,
        payload: err.response ? err.response.body : err,
      });
      throw new SubmissionError({
        _error: err.response ? err.response.body.messageKey : err,
      });
    });
};

export function setUnsubmittedPriorities(val) {
  return dispatch => {
    dispatch({ type: SET_UNSUBMITTED_PRIORITIES, payload: val });
  };
}

export const selectHealthReviewTab = tabIndex => ({
  type: SELECT_HEALTH_REVIEW_TAB,
  payload: {
    selectedTab: tabIndex,
  },
});



// WEBPACK FOOTER //
// ./actions/hraResultActions.jsx